import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import PropTypes from "prop-types";
import { handleApiError } from "@utils/errorHandler";
import ClipLoader from "react-spinners/ClipLoader";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { Image } from "hesus-ui-kit";
import { DivToolTip } from "@utils/extra-style";
import {
  SyncIconWrapper,
  SyncSpinnerPosition,
  SyncSuccessMessage,
} from "@shared/styles/common.styled";
import editIcon from "@icons/ic-edit-blue.svg";
import deleteIcon from "@icons/ic-delete-red.svg";
import activateIcon from "@icons/ic-activate.svg";
import opsActivateIcon from "@icons/ic-activate-blue.svg";
import opsDeactivateIcon from "@icons/ic-activate-grey.svg";
import communicationIcon from "@icons/ic-communication.svg";
import DiscussionList from "../../../../Discussion/DiscussionList/DiscussionList";
import {
  GridRow,
  ProductTitle,
  ButtonWrapper,
  ButtonData,
  ParentDetail,
  CommunicationButtonWrapper,
} from "../../CompanyView.styled";
import "../../CompanyView.scss";

const Header = (props) => {
  const { t, companyData, handleCompanyStatus, setIsRefeshData } = props;
  const params = useParams();
  const history = useNavigate();
  const [communicationBox, setCommunicationBox] = useState(false);

  const [isSyncRunning, setIsSyncingRunning] = useState(false);
  const [syncSuccess, setSyncSuccess] = useState(false);

  const onEdit = () => {
    history(`/company/edit/${companyData.id}`);
  };

  const openCommunicationBox = () => {
    setCommunicationBox(true);
  };
  const onCommunicationBoxCancel = () => {
    setCommunicationBox(false);
  };

  const updateSyncStatus = () => {
    if (isSyncRunning) return;
    setIsSyncingRunning(true);
    axios
      .post(`/companies/${companyData.id}/syncOps`)
      .then((response) => {
        setIsSyncingRunning(false);
        setIsRefeshData(true);
        setSyncSuccess(true);
        setTimeout(() => setSyncSuccess(false), 3000);
      })
      .catch((error) => {
        setIsSyncingRunning(false);
        handleApiError(error);
      });
  };

  return (
    <>
      <GridRow column="1fr 1fr">
        <ProductTitle>
          # {companyData.id + " - " + companyData.name}
        </ProductTitle>
        <ButtonWrapper>
          <ButtonData
            color={companyData.isActive === 1 ? "#32A728" : "#E83F1E"}
          >
            {companyData.isActive === 1 ? t("ACTIVE") : t("INACTIVE")}
          </ButtonData>

          {params.path === "general-info" && (
            <>
              <Image
                src={editIcon}
                alt={t("COMPANY_ACTION_TOOLTIP_EDIT")}
                id={`company-edit-tooltip-id${companyData.id}`}
                className="company-centre-view__image-icon-header-company"
                onClick={onEdit}
              />
              <Tooltip
                anchorSelect={`#company-edit-tooltip-id${companyData.id}`}
                style={DivToolTip}
                content={t("COMPANY_ACTION_TOOLTIP_EDIT")}
              />
              <SyncIconWrapper>
                {!isSyncRunning ? (
                  <>
                    <Image
                      src={
                        companyData.isErpSync === 1
                          ? opsActivateIcon
                          : opsDeactivateIcon
                      }
                      alt={t("COMPANY_ACTION_TOOLTIP_REFRESH_OPS")}
                      id={`company-sync-tooltip-id${companyData.id}`}
                      className="company-centre-view__image-icon-header-company"
                      onClick={updateSyncStatus}
                    />
                    <Tooltip
                      place="top"
                      positionStrategy="fixed"
                      anchorSelect={`#company-sync-tooltip-id${companyData.id}`}
                      style={DivToolTip}
                      content={t("COMPANY_ACTION_TOOLTIP_REFRESH_OPS")}
                    />
                  </>
                ) : (
                  <SyncSpinnerPosition>
                    <ClipLoader size={15} color="#9d9797" />
                  </SyncSpinnerPosition>
                )}
                {syncSuccess && (
                  <SyncSuccessMessage>
                    {t("OPS_SYNC_MANUAL_EXECUTED")}
                  </SyncSuccessMessage>
                )}
              </SyncIconWrapper>
              {companyData.isActive === 1 && (
                <>
                  <Image
                    src={deleteIcon}
                    alt={t("COMPANY_ACTION_TOOLTIP_DISABLE")}
                    id={`company-disable-tooltip-id${companyData.id}`}
                    className="company-centre-view__image-icon-header-company"
                    onClick={() => handleCompanyStatus(0)}
                  />
                  <Tooltip
                    anchorSelect={`#company-disable-tooltip-id${companyData.id}`}
                    style={DivToolTip}
                    content={t("COMPANY_ACTION_TOOLTIP_DISABLE")}
                  />
                </>
              )}
              {companyData.isActive !== 1 && (
                <>
                  <Image
                    src={activateIcon}
                    alt={t("COMPANY_ACTION_TOOLTIP_ACTIVATE")}
                    id={`company-activate-tooltip-id${companyData.id}`}
                    className="company-centre-view__image-icon-header-company"
                    onClick={() => handleCompanyStatus(1)}
                  />
                  <Tooltip
                    anchorSelect={`#company-activate-tooltip-id${companyData.id}`}
                    style={DivToolTip}
                    content={t("COMPANY_ACTION_TOOLTIP_ACTIVATE")}
                  />
                </>
              )}
            </>
          )}
        </ButtonWrapper>
      </GridRow>
      {companyData.parentCompany?.id && (
        <GridRow column="1fr" marginTop="-20px">
          <ParentDetail>
            {t("COMPANY_CHILD_OF")}&nbsp;
            <Link
              className="company-centre-view__parent-link "
              to={`/company/view/${companyData.parentCompany?.id}/general-info`}
            >
              #{" "}
              {companyData?.parentCompany?.id +
                "-" +
                companyData?.parentCompany?.name}
            </Link>
          </ParentDetail>
        </GridRow>
      )}
      <GridRow column="1fr 47rem">
        <div>
          {!!companyData.isClient && (
            <ButtonData marginRight="10px">{t("CLIENT")}</ButtonData>
          )}
          {!!companyData.isSupplier && (
            <ButtonData marginRight="10px">{t("SUPPLIER")}</ButtonData>
          )}
          {!!companyData.isCentre && (
            <ButtonData marginRight="10px">{t("CENTRE")}</ButtonData>
          )}
          {!!companyData.isHaulier && (
            <ButtonData marginRight="10px">{t("HAULIER")}</ButtonData>
          )}
        </div>
        <CommunicationButtonWrapper>
          <Image
            src={communicationIcon}
            alt={t("COMMUNICATION")}
            title={t("COMMUNICATION")}
            marginLeft="7px"
            onClick={() => openCommunicationBox()}
            className="company-centre-view__image-icon-header-comm"
          />
          {communicationBox && (
            <DiscussionList
              entityType={1}
              entityId={companyData.id}
              onClose={onCommunicationBoxCancel}
            />
          )}
        </CommunicationButtonWrapper>
      </GridRow>
    </>
  );
};

Header.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(Header);
